import { Files, Clock, CheckCircle, ChartBar } from '@phosphor-icons/react';

const fmtInr = (n) => new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', maximumFractionDigits: 0 }).format(n || 0);

export const AgencyFileStatsCards = ({ stats }) => {
  if (!stats) return null;
  return (
    <div className="grid grid-cols-2 sm:grid-cols-4 gap-3" data-testid="agency-files-stats">
      <div className="bg-white border border-gray-200 rounded-lg p-3">
        <div className="flex items-center gap-2 text-gray-500 text-xs mb-1"><Files size={14} /> Total Files</div>
        <p className="text-xl font-bold text-gray-900" data-testid="stat-total-files">{stats.total_files}</p>
      </div>
      <div className="bg-white border border-gray-200 rounded-lg p-3">
        <div className="flex items-center gap-2 text-amber-600 text-xs mb-1"><Clock size={14} /> Pending</div>
        <p className="text-xl font-bold text-amber-700" data-testid="stat-pending">{stats.status_counts?.pending || 0}</p>
      </div>
      <div className="bg-white border border-gray-200 rounded-lg p-3">
        <div className="flex items-center gap-2 text-green-600 text-xs mb-1"><CheckCircle size={14} /> Completed</div>
        <p className="text-xl font-bold text-green-700" data-testid="stat-completed">{stats.status_counts?.completed || 0}</p>
      </div>
      <div className="bg-white border border-gray-200 rounded-lg p-3">
        <div className="flex items-center gap-2 text-blue-600 text-xs mb-1"><ChartBar size={14} /> Total Debited</div>
        <p className="text-xl font-bold text-blue-700" data-testid="stat-total-debited">{fmtInr(stats.total_debited)}</p>
      </div>
    </div>
  );
};
